<template>
  <select class="form-control" ref="selectElement">
    <option></option>
    <slot></slot>
  </select>
</template>
<script>
import select2 from 'select2';
select2();

export default {
  data() {
    return {
      defaultSelect2Options: {
        theme: 'bootstrap4',
        placeholder: this.placeholder,
        allowClear: this.allowClear,
        disabled: this.disabled
      }
    }
  },
  props: {
    options: {
      default: null
    },
    modelValue: {
      default: null
    },
    placeholder: {
      default: 'select...',
    },
    allowClear: {
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    select2Options: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    initSelect2: function () {
      const $element = $(this.$refs.selectElement);

      if (this.modelValue) {
        $(this.$el).val(this.modelValue);
      }
      let vm = this;

      // init select2
      $element.select2({
        ...this.defaultSelect2Options,
        ...this.select2Options,
        data: this.options,
      });
      $element.on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
      });
      $element.on('select2:select', (e) => {
        // this.emitInput(e.params?.data?.id);
      });
      $element.on('change', (e) => {
        this.emitInput(e.target.value);
      });
      $element.on('select2:unselect', (e) => {
        this.emitInput(null)
      });
      $element.on('select2:clean', (e) => {
        this.emitInput(null)
      });
      if (this.modelValue) {
        $element.val(this.modelValue).trigger('change');
      }
    },
    emitInput: function (value) {
      if (value !== this.modelValue) {
        this.$emit('update:modelValue', value ?? null);
      }
    }
  },
  mounted: function () {
    this.initSelect2()
  },
  watch: {
    modelValue: function (value) {
      const $element = $(this.$refs.selectElement);
      this.$nextTick(() => {
        $element.val(value).trigger('change');
        $element.trigger({
          type: 'select2:select',
          params: {
            data: {
              id: value
            }
          }
        });
      });
    },
    options: function (options) {
      const $element = $(this.$refs.selectElement);
      $element.off().select2('destroy')
      this.initSelect2();
    },
    disabled: function (disabled) {
      const $element = $(this.$refs.selectElement);
      $element.prop("disabled", disabled);
    },
    select2Options: function (select2Options) {
      const $element = $(this.$refs.selectElement);
      $element.off().select2('destroy')
      this.initSelect2();
    }
  },
  unmounted: function () {
    const $element = $(this.$refs.selectElement);
    $element.off().select2('destroy')
  }
}
</script>
<style>
.select2-container--bootstrap4 .select2-dropdown {
  border-color: #5cb3fd;
}

.select2-container--bootstrap4.select2-container--focus .select2-selection, .select2-container--bootstrap4.select2-container--open .select2-selection {
  border-color: #5cb3fd;
}

.select2-container--bootstrap4 .select2-dropdown.select2-dropdown--above {
  border-top: 1px solid #5cb3fd;
  margin-top: 1px;
}


.select2-results__option[aria-selected]{
  padding: 0.5rem;
}


.select2-container--bootstrap4 .select2-results__option[role=group] .select2-results__options--nested .select2-results__option{
  padding-left: 1rem;
}

.select2-container--bootstrap4 .select2-results__group{
  font-weight: 500;
  background-color: #efefef;
  color: #555555;
}




</style>